import { checkoutRoutes } from '../../../config/routes.config';

export default checkoutRoutes;
